import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MessageCircle, ChevronRight, MapPin, Clock } from 'lucide-react';

export default function Footer({ t, categoryInfo }) {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const categoryRoutes = {
    Automobiles: '/automobiles',
    Bateaux: '/bateaux',
    Bungalows: '/bungalows',
  };

  const handleEmailClick = () => {
    const email = "technicimport33@gmail.com";
    const subject = "Demande d'information Technic Import";
    
    // Détection si c'est un mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // Sur mobile, on lance l'application native (Gmail/Mail)
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
    } else {
      // Sur PC, on ouvre directement Gmail dans un nouvel onglet
      // Cela évite l'onglet vide de Chrome et l'ouverture d'Outlook par erreur
      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}`;
      window.open(gmailUrl, '_blank');
    }
  };

  return (
    <footer className="bg-[#0a0d12] text-gray-500 pt-20 pb-10 border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">

        {/* Grille principale */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

          {/* Colonne 1 — Branding */}
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-black italic tracking-tighter uppercase text-white leading-none">
                TECHNIC<span className="text-red-600">IMPORT</span>
              </h3>
              <p className="text-[9px] text-gray-600 uppercase tracking-[0.4em] font-bold mt-2">Expertise Outre-Mer</p>
            </div>

            <p className="text-sm leading-relaxed font-medium">
              Solutions d'importation premium de véhicules neufs et d'équipements. Service clé en main pour les zones Outre-Mer.
            </p>

            <div className="space-y-3 pt-2">
              <div className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-wider text-gray-400">
                <MapPin size={14} className="text-red-600" />
                <span>NC · Polynésie · Réunion</span>
              </div>
              <div className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-wider text-gray-400">
                <Clock size={14} className="text-red-600" />
                <span>Lun – Sam · 24/24h</span> <br/> <span>Dim · 08:00 – 18:00</span>
              </div>
            </div>
          </div>

          {/* Colonne 2 — Navigation */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-[0.3em] mb-8 text-white">
              Navigation
            </h4>
            <ul className="space-y-4">
              {[
                { label: t.home, path: '/' },
                { label: t.ourStock, path: '/stock' },
                { label: t.financing, path: '/financing' },
              ].map(({ label, path }) => (
                <li
                  key={path}
                  onClick={() => navigate(path)}
                  className="group flex items-center gap-2 text-[12px] font-bold uppercase tracking-widest hover:text-white cursor-pointer transition-all"
                >
                  <div className="w-0 h-px bg-red-600 group-hover:w-4 transition-all" />
                  {label}
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 3 — Univers */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-[0.3em] mb-8 text-white">
              Univers
            </h4>
            <ul className="space-y-4">
              {categoryInfo && Object.entries(categoryInfo).map(([key, { name }]) => (
                <li
                  key={key}
                  onClick={() => navigate(categoryRoutes[key] || '/stock')}
                  className="group flex items-center gap-3 text-[12px] font-bold uppercase tracking-widest hover:text-white cursor-pointer transition-all"
                >
                   <ChevronRight size={14} className="text-red-600 group-hover:translate-x-1 transition-transform" />
                  {name}
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 4 — Contact Direct */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-[0.3em] mb-8 text-white">
              Contact direct
            </h4>
            <div className="space-y-3">
              {/* WhatsApp */}
              <button
                onClick={() => window.open('https://wa.me/+33601905164', '_blank')}
                className="flex items-center gap-4 w-full p-3 bg-white/5 border border-white/5 rounded-xl hover:bg-white/10 hover:border-red-600/30 transition-all text-left group"
              >
                <MessageCircle size={18} className="text-gray-400 group-hover:text-red-500 transition-colors" />
                <div>
                  <div className="text-[10px] font-black uppercase text-white tracking-tighter">WhatsApp</div>
                  <div className="text-[10px] text-gray-500 font-medium">Réponse instantanée</div>
                </div>
              </button>

              {/* Email - Avec la nouvelle logique PC/Mobile */}
              <button
                onClick={handleEmailClick}
                className="flex items-center gap-4 w-full p-3 bg-white/5 border border-white/5 rounded-xl hover:bg-white/10 hover:border-red-600/30 transition-all text-left group"
              >
                <Mail size={18} className="text-gray-400 group-hover:text-red-500 transition-colors" />
                <div>
                  <div className="text-[10px] font-black uppercase text-white tracking-tighter">Email</div>
                  <div className="text-[10px] text-gray-500 font-medium">technicimport33@gmail.com</div>
                </div>
              </button>

              {/* Instagram */}
              <button
                onClick={() => window.open('https://www.facebook.com/people/Technic-import-outre-mer/61583760578874', '_blank')}
                className="flex items-center gap-4 w-full p-3 bg-white/5 border border-white/5 rounded-xl hover:bg-white/10 hover:border-red-600/30 transition-all text-left group"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" className="text-gray-400 group-hover:text-red-500 transition-colors"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                <div>
                  <div className="text-[10px] font-black uppercase text-white tracking-tighter">Facebook</div>
                  <div className="text-[10px] text-gray-500 font-medium">Actualités & Stock</div>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Pied de page final */}
        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-6">
            <a href="#" className="flex items-center gap-2 group">
              <Phone size={14} className="text-red-600" />
              <span className="text-[11px] font-black text-white group-hover:text-red-500 transition-colors">Service en cours</span>
            </a>
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full shadow-[0_0_8px_rgba(34,197,94,0.6)]" />
              <span className="text-[9px] font-black uppercase text-gray-600 tracking-widest">Opérationnel</span>
            </div>
          </div>

          <p className="text-[9px] font-bold uppercase tracking-[0.3em] text-gray-700">
            © {year} TECHNIC IMPORT · <span className="hover:text-white cursor-pointer transition-colors">Légal</span> · <span className="hover:text-white cursor-pointer transition-colors">Privacy</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
